/**
 * Created by rickborst on 12/06/2017.
 */

class Navigation {

    /**
     * Constructs the instance.
     *
     * @param {Object} [options] - Options object.
     */
    constructor (options = {}) {

        this.label = options.label || '';
        this.route = options.route || '/';
        this.query = options.query || '';
    }
}

export default Navigation;


// WEBPACK FOOTER //
// ./src/js/models/navigation.js